import React, { useState } from "react";
import axios from "axios";
import { Container, Row, Col, Button, Spinner, Badge } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const suggestions = [
  "total good products of machine 74 this week",
  "daily breakdown of machine 74 for March 2026",
  "shift wise production of machine 74 on 17/03/2026",
  "good and bad products from 10/03/2026 to 17/03/2026",
  "which day had the highest bad products in March?",
  "compare shift 1 vs shift 2 production this week",
];

const SearchInput = () => {
  const [query, setQuery] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = async (q = query) => {
    if (!q.trim()) return;

    try {
      setLoading(true);
      setAnswer("");
      setQuery(q); // fill input when chip clicked

      const res = await axios.post(
        "https://api.hanoch.in/ai/ask/",
        {
          question: q,
        }
      );
console.log("API response:", res?.data);
      setAnswer(res?.answer);
    } catch (err) {
      console.error(err);
      setAnswer("Failed to fetch response");
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="OptiMize" breadcrumbItem="Search" />

          {/* 🔥 Chips Section */}
          <Row className="justify-content-center mb-3">
            <Col md="8" className="d-flex flex-wrap gap-2">
              {suggestions.map((item, index) => (
                <Badge
                  key={index}
                  pill
                  onClick={() => handleSearch(item)}
                  style={{
                    cursor: "pointer",
                    padding: "10px 14px",
                    background: "#eef2ff",
                    color: "#333",
                    borderRadius: "20px",
                    fontSize: "13px",
                  }}
                >
                  {item}
                </Badge>
              ))}
            </Col>
          </Row>

          {/* 🔍 Search Input */}
          <Row className="justify-content-center mb-3">
            <Col md="6" className="d-flex gap-2">
              <input
                type="text"
                placeholder="Ask something..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleSearch();
                }}
                style={{
                  padding: "10px 12px",
                  width: "100%",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                }}
              />

              <Button color="primary" onClick={() => handleSearch()}>
                Search
              </Button>
            </Col>
          </Row>

          {/* 📊 Answer */}
          <Row className="justify-content-center">
            <Col md="6">
              {loading ? (
                <div className="text-center">
                  <Spinner />
                </div>
              ) : (
                answer && (
                  <div
                    style={{
                      padding: "15px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      background: "#f9f9f9",
                    }}
                  >
                    <strong>Answer:</strong>
                    <p style={{ marginTop: "10px" }}>{answer}</p>
                  </div>
                )
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SearchInput;